import React, { useEffect, useState } from "react";
import {
  REPAIR_EVALUATION_REJECTED,
  WORKING_TO_SAVE_UNIT
} from "MODULES/inventories/constants";
import { Col, Row, OverlayTrigger, Tooltip } from "react-bootstrap";
import api from "APP_ROOT/api";
import { APPROVAL_STATUS } from "MODULES/RepairOrders/constants";
import ClipboardCopy from "MODULES/shared/components/ClipboardCopy";
import Table from "./Table";

function RequiredComponents({ lineItem, getFieldValue }) {
  if (!lineItem) return null;

  const [requiredComponents, setRequiredComponents] = useState([]);

  useEffect(
    () => {
      api.repairOrders.lineItems.requiredComponents
        .search(lineItem.id, { reverse: false })
        .then(({ data }) => {
          setRequiredComponents(data.results);
        });

      return function cleanup() {};
    },
    [lineItem.id]
  );

  if (
    ![REPAIR_EVALUATION_REJECTED, WORKING_TO_SAVE_UNIT].includes(
      getFieldValue(APPROVAL_STATUS)
    ) &&
    requiredComponents.length === 0
  ) {
    return null;
  }

  const partNumbers = requiredComponents
    .map(comp => comp.part.part_number)
    .join("\n");

  const tooltip = (
    <Tooltip id="tooltip-copy-all">Copy all part numbers</Tooltip>
  );

  return (
    <div>
      <Row>
        <Col sm={12}>
          <h2>Required Components</h2>
          <OverlayTrigger placement="left" overlay={tooltip}>
            <div>
              <ClipboardCopy
                name={partNumbers}
                handleClick={() => navigator.clipboard.writeText(partNumbers)}
              />
            </div>
          </OverlayTrigger>
          <br />
        </Col>
      </Row>
      <Table requiredComponents={requiredComponents} />
    </div>
  );
}

export default RequiredComponents;



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/FormSections/RequiredComponents/RequiredComponents.jsx